import accountExtensions from "@/services/account.extensions";
import notification from "@/services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        isExistingSubdomain: false,
        form: {
            merchant_subdomain: null,
            customer_subdomain: null
        },
        gtmData: {}
    },
    mutations: {
        setLoading(state, value) {
            state.loading = value;
        },
        stepone(state) {
            state.stepne = rewards;
            state.loading = false;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setIsExistingSubdomain(state, value) {
            state.isExistingSubdomain = value;
        },
        setSubdomains(state, value) {
            state.form.merchant_subdomain = value.merchant;
            state.form.customer_subdomain = value.customer;
        },
        setGtmData(state, data) {
            state.gtmData = data;
        }
    },
    actions: {
        async checkSubdomain({ commit }, subdomain) {
            commit("setLoading", true);
            commit("setErrors", null);

            try {
                const response = await accountExtensions.checkSubdomain({
                    payload: { subdomain }
                });

                commit("setIsExistingSubdomain", response.exists);
            } catch (errors) {
                commit("setErrors", errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async getSubdomainUrl({ commit, state }) {
            let param = {
                formatted: true
            };

            let response = await accountExtensions.getSubdomainUrlList({
                payload: param
            });

            let subdomains = {
                merchant: response.merchant_subdomain[0].subdomain,
                customer: response.customer_subdomain[0].subdomain
            };

            commit("setSubdomains", subdomains);
        },
        async updateSubdomain({ commit }, subdomain) {
            commit("setLoading", true);
            commit("setErrors", null);

            try {
                const response = await accountExtensions.updateSubdomain({
                    payload: { subdomain }
                });

                notification.success(response.message);
            } catch (errors) {
                commit("setErrors", errors);

                notification.warning("Oops, cannot save subdomain.");
            } finally {
                commit("setLoading", false);
                
            }
        },
        async getGoogleTagManager({ commit }) {
            commit("setLoading", true);
            try {
                const { data } = await accountExtensions.getGoogleTagManager();
                commit("setGtmData", data);
            } catch (errors) {
                commit("setErrors", errors.errors);
            } finally {
                commit("setLoading", false);
            }
        },
        async saveGoogleTagManage({ commit }, payload) {
            commit("setLoading", true);
            try {
                const { data, message } = await accountExtensions.saveGoogleTagManage(payload);
                commit("setGtmData", data);
                notification.success(message ? message : "Container ID has been successfully saved.");
            } catch (errors) {
                commit("setErrors", errors.errors);
            } finally {
                commit("setLoading", false);
            }
        }
    }
};
